export default "__VITE_ASSET__DB7mAg3R__"